import MuiAvatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100svh;
  padding-top: 32px;
  gap: 50px;
`;

export const Content = styled(Box)`
  display: flex;
  max-width: 610px;
  width: 100%;
  height: 80%;
  flex: 1;
  flex-direction: column;
  gap: 66px;
`;

export const Header = styled(Box)`
  display: flex;
  max-width: 610px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const RatingWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const Footer = styled(Box)`
  display: flex;
  height: 334px;
  width: 100%;
  flex-direction: column;
  background-color: green;
  gap: 50px;
`;

export const Title = styled(Typography)`
  color: var(--colours-primary-rkbt-green, #36bba0);
  font-family: "NotoSans-Medium";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
`;

export const SubTitle = styled(Typography)`
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 155.556% */
`;

export const Skip = styled(Typography)`
  color: rgba(0, 0, 0, 0.54);
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  cursor: pointer;
`;

export const PlayersContainer = styled(Box)`
  display: flex;
  overflow-y: auto;
  height: 80vh;
  flex-direction: column;
  gap: 20px;
`;

export const PlayerInfoWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const OptionWithDividerWrapper = styled(Box)`
  display: flex;
  width: 100%;
  gap: 10px;
  flex-direction: column;
`;

export const OptionWithIconWrapper = styled(Box)`
  display: flex;
`;

export const PlayerWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Avatar = styled(MuiAvatar)`
  width: 28px;
  height: 28px;
  background-color: var(--colours-grey-400, #a0aec0);
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const PlayerName = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const TeamDescription = styled(Typography)`
  color: var(--colours-grey-500, #718096);
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
